/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {selector, selectorFamily, waitForAll} from 'recoil';
import {
  currentGameIDInitialState,
  currentGameIDState,
  currentSceneIDState,
  currentUserIDState,
} from './atoms';
import {
  getCurrentUser,
  getGame,
  getScene,
  setLatestWatchedSceneID,
} from '../Api';

export const currentGameInfoQuery = selector({
  key: 'CurrentGameInfoQuery',
  get: async ({get}) => {
    const response = await getGame({
      id: get(currentGameIDState)
    });

    if (response.error) {
      throw response.error;
    }

    return response.game;
  }
});

export const latestWatchedSceneIDQuery = selector({
  key: 'CurrentUserHistoryInfoQuery',
  set: async ({set, get}, newValue) => {
    const history = {
      sceneID: get(currentSceneIDState),
      userID:  get(currentUserIDState),
      gameID:  get(currentGameIDState)
    };
    const response = await setLatestWatchedSceneID(history);
    if (response.error) {
      throw response.error;
      //console.log('error');
    }


    return response.latestWatchedSceneID;
  }
});

export const currentSceneInfoQuery = selector({
  key: 'CurrentSceneInfoQuery',
  get: async ({get}) => {
    const currentSceneID = get(currentSceneIDState);
    if(currentSceneID) {
      return get(sceneInfoQuery(get(currentSceneIDState)));
    }
  },
});

export const currentUserInfoQuery = selector({
  key: 'CurrentUserInfoQuery',
  get: ({get}) => get(userInfoQuery(get(currentUserIDState)))
});

const userInfoQuery = selectorFamily({
  key: 'UserInfoQuery',
  get: userID => async ({get}) => {
    const response = await getCurrentUser({
      id: userID
    });
    if (response.error) {
      throw response.error;
    }
    return response.user;
  },
});

export const sceneInfoQuery = selectorFamily({
  key: 'SceneInfoQuery',
  get: sceneID => async ({get}) => {
    if (!sceneID) return;
    const response = await getScene({
      id: sceneID
    });
    if (response.error) {
      throw response.error;
    }

    return response.scene;
  },
});

export const gameHighlightScenesQuery = selector({
  key: 'GameHighlightScenes',
  get: ({get}) => {
    const currentGame = get(currentGameInfoQuery);

    return get(waitForAll(
        currentGame.storyHighlights.map(sceneID => sceneInfoQuery(sceneID))
    ));
  },
});

export const currentSceneIDSelector = selector({
  key: 'currentSceneIDSelector',
  get: async ({get}) => {
    const history = {
      sceneID: get(currentSceneIDState),
      userID:  get(currentUserIDState),
      gameID:  get(currentGameIDState)
    };
    await setLatestWatchedSceneID(history);
    return get(currentSceneIDState)
  }
});
